module.exports = "<div>\n    <img src=\"assets\\attachments\\{{data.src}}\" (click)=\"photoDet($event)\">\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/DesignPhotos/photos.component.html
// module id = ../../../../../src/app/components/report/DesignPhotos/photos.component.html
// module chunks = main